import { RfxTab, RfxTabTotals } from "newui/features/Rfx/types/component-types";
import { useMemo } from "react";
import { Rfx, RfxType } from "newui/features/Rfx/types/rfx.types";
import { RFX_TABS } from "utils/constants";

export interface TabItem {
	id: RfxTab;
	name: string;
	showBadge: boolean;
	total: number;
	isValid: boolean;
	sortOrder: number;
}

export const getTabCounts = (
	rfx: Rfx,
	questionnaireLength?: number,
	quoteLength?: number
): RfxTabTotals => {
	return {
		addendums: rfx?.addendum_count ?? 0,
		comms: rfx?.comms_count ?? 0,
		documentation: rfx?.documentationDocument?.length ?? 0,
		returnableSchedule:
			rfx?.returnableScheduleType === "file" ? 1 : (questionnaireLength ?? 0),
		quote: rfx?.quoteType === "file" ? 1 : (quoteLength ?? 0),
	} as RfxTabTotals;
};

export const useTabMenu = (rfxType: RfxType, tabCounts: RfxTabTotals) => {
	const showQuote = rfxType?.show_quote ?? true;

	const tabMenu = useMemo(() => {
		const quoteTab: TabItem = {
			id: RFX_TABS.QUOTE,
			name: "Quote",
			showBadge: true,
			total: tabCounts.quote,
			isValid: false,
			sortOrder: 3,
		};

		const tabs: TabItem[] = [
			{
				id: RFX_TABS.DOCUMENTATION,
				name: "Documentation",
				showBadge: true,
				total: tabCounts.documentation,
				isValid: true,
				sortOrder: 1,
			},
			{
				id: RFX_TABS.QUESTIONNAIRE,
				name: "Returnable Schedules",
				showBadge: true,
				total: tabCounts.returnableSchedule,
				isValid: false,
				sortOrder: 2,
			},
			{
				id: RFX_TABS.COMMS,
				name: "Comms",
				showBadge: true,
				total: tabCounts.comms,
				isValid: true,
				sortOrder: 4,
			},
			{
				id: RFX_TABS.ADDENDUMS,
				name: "Addendums",
				showBadge: true,
				total: tabCounts.addendums,
				isValid: true,
				sortOrder: 5,
			},
		];

		if (showQuote) {
			tabs.push(quoteTab);
		}

		return tabs.sort((a, b) => a.sortOrder - b.sortOrder);
	}, [showQuote, tabCounts]);

	return { tabMenu };
};
